import { Day } from "../../offering/day_utils";

export interface BlockOutDateInput {
  startDate: Day;
  endDate: Day;
  reason: string;
  blockableType: string;
  blockableID: string;
}

export enum BlockableType {
  SpacePartner = "SpacePartner",
  Location = "Location",
  Space = "Space",
}

export interface BlockOutDate {
  id: string;
  startDate: string;
  endDate: string;
  reason: string;
  blockableType: BlockableType;
  blockableID: string;
  blockableName: string;
}

export interface BlockOutDateLocation {
  id: string;
  name: string;
  streetAddress: string;
  city: string;
}

export interface BlockOutDateDetails extends BlockOutDate {
  location: BlockOutDateLocation;
}

export interface DateRangeParam {
  startDate: string;
  endDate: string;
}

export function toBlockOutDate(data: any): BlockOutDate {
  return {
    id: data.id,
    startDate: data.start_date,
    endDate: data.end_date,
    reason: data.reason,
    blockableType: data.blockable_type,
    blockableID: data.blockable_id,
    blockableName: data.blockable_name,
  };
}

export function toBlockOutDateDetails(data: any): BlockOutDateDetails {
  return {
    id: data.id,
    startDate: data.start_date,
    endDate: data.end_date,
    reason: data.reason,
    blockableType: data.blockable_type,
    blockableID: data.blockable_id,
    blockableName: data.blockable_name,
    location: {
      id: data.location.id,
      name: data.location.name,
      streetAddress: data.location.street_address,
      city: data.location.city,
    },
  };
}
